import { Snackbar } from '@material/react-snackbar';
import './Snackbar.scss';

/**
 * Snackbar MCWR Component
 *
 * @version ./package.json
 */
export default Snackbar;